import type { LayoutStackGap, LayoutStackProps } from './LayoutStack.types'

/**
 * layout-stack — feature-blind vertical spacing container.
 *
 * One block-level flex column: children stacked top-to-bottom in order,
 * separated by a single uniform gap chosen solely from `gap` (strictly
 * increasing scale, spacing-scale utilities only). No padding, border, or
 * background of its own; holds no state, emits no events.
 */
const gaps: Record<LayoutStackGap, string> = {
  sm: 'gap-2',
  md: 'gap-4',
  lg: 'gap-8',
}

export function LayoutStack({ gap = 'md', children }: LayoutStackProps) {
  return <div className={`flex flex-col ${gaps[gap]}`}>{children}</div>
}
